import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthProvider } from '../providers/auth/auth';
import { CacheService } from 'ionic-cache';

import { LoginPage } from '../pages/login/login';
@Component({
  templateUrl: "app.html"
})
export class MyApp {
  rootPage: any = LoginPage;
  isLoggedIn: boolean;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    private authProvider: AuthProvider,
    cache: CacheService
  ) {
    platform.ready().then(() => {
      // Set TTL to 12h
      cache.setDefaultTTL(60 * 60 * 12);

      // Keep our cached results when device is offline!
      cache.setOfflineInvalidate(false);
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });

    this.authProvider.getAuth().subscribe(auth => {
      if (auth) {
        this.isLoggedIn = true;
        this.rootPage = "HomePage";
      } else {
        this.isLoggedIn = false;
        this.rootPage = LoginPage;
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts